import { normalizeApiError, showToastFromError } from "./apiHelpers"

export const ADD_TOAST = "ADD_TOAST"
export const REMOVE_TOAST = "REMOVE_TOAST"

// Compteur module-level : ids stables, pas de collision.
let _toastId = 0

// Anti-spam : un même toast danger/warning n'est pas ré-émis dans cette
// fenêtre (polling en échec réseau, double-clic…). Les succès toastent
// toujours — l'utilisateur attend un feedback par sauvegarde.
const REPEAT_WINDOW_MS = 30000
const _lastShown = {}

export const removeToast = (id) => ({ type: REMOVE_TOAST, id })

// level: "danger" | "warning" | "success" | "info"
export function showToast(level, message, duration = 4000) {
	return (dispatch) => {
		if (level === "danger" || level === "warning") {
			const key = `${level}|${message}`
			const now = Date.now()
			if (_lastShown[key] && now - _lastShown[key] < REPEAT_WINDOW_MS) {
				return null
			}
			_lastShown[key] = now
		}
		const id = ++_toastId
		dispatch({ type: ADD_TOAST, toast: { id, level, message } })
		if (duration > 0) {
			setTimeout(() => dispatch(removeToast(id)), duration)
		}
		return id
	}
}

// Helper : transforme n'importe quelle erreur d'appel API en toast, via le
// payload normalisé (tolère l'enveloppe standard {message, level}, l'ancienne
// {msg, status}, {"error": ...}, et les réponses non-JSON / pannes réseau).
export function toastApiError(err) {
	return (dispatch) =>
		normalizeApiError(err).then((payload) =>
			dispatch(showToastFromError(payload)),
		)
}
